import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/brand-logo";
import { useLanguage } from "@/components/language-provider";

const TEXT = {
  pt: ["A página que você procura não existe.", "Voltar ao início"],
  en: ["The page you are looking for does not exist.", "Back to home"],
  es: ["La página que busca no existe.", "Volver al inicio"],
};

export default function NotFound() {
  const { language } = useLanguage();
  const [message, back] = TEXT[language];
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <BrandLogo size="lg" className="justify-center mb-8" animated={true} />
        <h1 className="text-6xl font-display mb-4" style={{ color: "var(--fs-forest)" }}>404</h1>
        <p className="text-muted-foreground mb-8">{message}</p>
        <Link href="/">
          <Button variant="outline" className="rounded-full gap-2">
            <ArrowLeft className="w-4 h-4" />{back}
          </Button>
        </Link>
      </div>
    </div>
  );
}
